var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Avatar, message, Spin, Divider, Flex, Typography } from "@duxton-web/ui";
import { fetchMerchants, setSelectedMerchant } from './merchantSelectorSlice';
import { getSelectedMerchantIdFromLocalStorage, VIRTUAL_ENTITY } from "../../utils/merchantSelectorHelper";
import withProvider from "../../hoc/withProvider";
import { isVirtualEntitySystemEnabled } from "../../utils/featureFlagHelper";
import { ChevronRightUniversal } from "@duxton-web/icons";
import I18n from "i18n-js";
var Title = Typography.Title, Body = Typography.Body, Metadata = Typography.Metadata;
// TODO: Style fixes based on latest figma - wait for desk check or final figma
var styles = {
    avatarSmall: {
        cursor: 'pointer',
        margin: '0 20px',
    },
    container: {
        padding: '10px 5px',
        border: '1px solid #BFBFBF',
        borderRadius: '16px',
        cursor: 'pointer',
        margin: '20px 16px',
    },
    avatarIconModal: {
        minWidth: '40px',
        minHeight: '40px',
        maxWidth: '40px',
        maxHeight: '40px',
        marginLeft: '17px',
        marginRight: '20px',
    },
    avatarIcon: {
        minWidth: '40px',
        minHeight: '40px',
        maxWidth: '40px',
        maxHeight: '40px',
    },
    merchantInfo: {
        padding: '0 10px',
        cursor: 'pointer',
        width: "100px",
        flexGrow: '1',
    },
    merchantName: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    metadata: {
        color: "#707070",
        alignSelf: 'baseline',
    },
    chevronIcon: {
        fontSize: '24px',
        color: '#3D3D3D',
    },
    modalTitle: {
        marginTop: '5px',
    },
    modalSubtitle: {
        fontWeight: '400',
    },
    merchantOption: {
        cursor: 'pointer',
        flexGrow: 1,
    },
    merchantText: {
        display: 'flex',
        flexDirection: "column",
        flexGrow: 1,
        textAlign: 'left',
    },
    divider: {
        marginLeft: 'auto',
        minWidth: '81%',
        width: '81%',
        margin: '20px 0 20px auto'
    },
};
export var MerchantSelector = function (_a) {
    var _b = _a.collapsed, collapsed = _b === void 0 ? false : _b;
    if (!isVirtualEntitySystemEnabled())
        return null;
    var dispatch = useDispatch();
    var _c = useSelector(function (state) { return state.merchantSelector; }), merchants = _c.merchants, loading = _c.loading, error = _c.error, selectedMerchant = _c.selectedMerchant;
    var _d = __read(useState(false), 2), isModalVisible = _d[0], setIsModalVisible = _d[1];
    useEffect(function () {
        if (!merchants) {
            dispatch(fetchMerchants());
            return;
        }
        var storedMerchantId = getSelectedMerchantIdFromLocalStorage();
        var selectedMerchant = merchants === null || merchants === void 0 ? void 0 : merchants.find(function (merchant) { return merchant.id === storedMerchantId; });
        if (storedMerchantId && selectedMerchant) {
            dispatch(setSelectedMerchant(selectedMerchant));
        }
        else if ((merchants === null || merchants === void 0 ? void 0 : merchants.length) === 1) {
            dispatch(setSelectedMerchant(merchants[0]));
        }
        else if (!storedMerchantId) {
            setIsModalVisible(true);
        }
        else {
            var normalMerchant = merchants === null || merchants === void 0 ? void 0 : merchants.find(function (merchant) { return merchant.type !== VIRTUAL_ENTITY; });
            normalMerchant ? dispatch(setSelectedMerchant(normalMerchant)) : dispatch(setSelectedMerchant(merchants[0]));
        }
    }, [dispatch, JSON.stringify(merchants)]);
    var handleMerchantSelect = function (merchantId) {
        var selectedMerchant = merchants === null || merchants === void 0 ? void 0 : merchants.find(function (merchant) { return merchant.id === merchantId; });
        if (selectedMerchant) {
            dispatch(setSelectedMerchant(selectedMerchant));
            setIsModalVisible(false);
            window.location.href = "/portal";
        }
        else {
            message.error("Merchant not found");
        }
    };
    var getInitials = function (name) {
        var nameParts = name.split(" ");
        return nameParts.length > 1
            ? nameParts[0][0] + nameParts[1][0]
            : nameParts[0][0];
    };
    if (loading)
        return React.createElement(Spin, { "data-testid": "loading-spinner", size: "small" });
    if (error || !merchants || merchants.length <= 1)
        return null;
    return (React.createElement(React.Fragment, null,
        selectedMerchant && (collapsed ?
            React.createElement(Avatar, { size: "small", style: styles.avatarSmall, onClick: function () { return setIsModalVisible(true); } }, getInitials(selectedMerchant.display_name).toUpperCase()) :
            React.createElement(Flex, { align: "center", style: styles.container, onClick: function () { return setIsModalVisible(true); } },
                React.createElement(Flex, { align: "center", style: { width: '100%' } },
                    React.createElement(Avatar, { size: "small", style: styles.avatarIcon }, getInitials(selectedMerchant.display_name).toUpperCase()),
                    React.createElement(Flex, { vertical: true, style: styles.merchantInfo },
                        React.createElement(Body, { level: 2, style: styles.merchantName }, selectedMerchant.display_name),
                        selectedMerchant.type === VIRTUAL_ENTITY && (React.createElement(Metadata, { style: styles.metadata }, "Partial access") //TODO: Add Localisation
                        )),
                    React.createElement(ChevronRightUniversal, { style: styles.chevronIcon, onPointerEnterCapture: undefined, onPointerLeaveCapture: undefined })))),
        React.createElement(Modal, { title: 
            //TODO: Add Localisation
            React.createElement(React.Fragment, null,
                React.createElement(Title, { style: styles.modalTitle, level: 4 }, I18n.t("mex_shellBusiness_heading_selectBusiness", { defaultValue: "Select business?" })),
                React.createElement(Body, { style: styles.modalSubtitle, level: 3, type: "secondary" }, I18n.t("mex_shellBusiness_body_whichBusinessToAccess", { defaultValue: "Which business would you like to access?" }))), open: isModalVisible, onCancel: function () { return setIsModalVisible(false); }, footer: null, closable: !!getSelectedMerchantIdFromLocalStorage(), centered: true, maskClosable: !!getSelectedMerchantIdFromLocalStorage(), styles: {
                mask: { background: 'white' },
                body: { height: '80%', overflow: 'scroll', paddingBottom: '20px' },
                header: { fontWeight: "400", marginBottom: '20px' },
                content: { height: '428px', width: '440px', padding: '20px' }
            } },
            React.createElement(Flex, { vertical: true }, merchants.map(function (merchant, index) { return (React.createElement(React.Fragment, { key: merchant.id },
                React.createElement(Flex, { onClick: function () { return handleMerchantSelect(merchant.id); }, style: styles.merchantOption, align: "center" },
                    React.createElement(Avatar, { size: "small", style: styles.avatarIconModal }, getInitials(merchant.display_name).toUpperCase()),
                    React.createElement("div", { style: styles.merchantText },
                        React.createElement(Body, { level: 3, type: "secondary" }, merchant.display_name),
                        merchant.type === VIRTUAL_ENTITY ?
                            React.createElement(Metadata, { style: styles.metadata }, I18n.t("mex_shellBusiness_body_limitedAccess", { defaultValue: "Limited access" }))
                            :
                                React.createElement(Metadata, { style: styles.metadata }, I18n.t("mex_shellBusiness_body_fullAccess", { defaultValue: "Full access?" }))),
                    React.createElement(ChevronRightUniversal, { style: styles.chevronIcon, onPointerEnterCapture: undefined, onPointerLeaveCapture: undefined })),
                index < merchants.length - 1 && (React.createElement(Divider, { style: styles.divider })))); })))));
};
export default withProvider(MerchantSelector);
//# sourceMappingURL=merchantSelector.js.map